export const commaFormat = (...values: Array<string | undefined | null>) =>
  values
    .filter((v): v is string => typeof v === 'string')
    .reduce((acc, cur) => acc + (acc ? `, ${cur}` : cur), '')
